export enum Locales {
  NlNL = 'nl-NL',
  EnUS = 'en-US',
  EsES = 'es-ES',
  DeDE = 'de-DE',
  PlPL = 'pl-PL',
  DaDK = 'da-DK',
  SvSE = 'sv-SE',
  NbNO = 'nb-NO',
  ItIT = 'it-IT',
  FrFR = 'fr-FR',
  // Declared before PtBR: a device reporting a bare "pt" resolves to the first match.
  PtPT = 'pt-PT',
  PtBR = 'pt-BR',
}

export const fallbackLocale = Locales.EnUS;

// Endonyms: a language is named in its own language, so these never get translated.
export const localeToLabelMap: Record<Locales, string> = {
  [Locales.DaDK]: 'Dansk',
  [Locales.DeDE]: 'Deutsch',
  [Locales.EnUS]: 'English',
  [Locales.EsES]: 'Español',
  [Locales.FrFR]: 'Français',
  [Locales.ItIT]: 'Italiano',
  [Locales.NbNO]: 'Norsk',
  [Locales.NlNL]: 'Nederlands',
  [Locales.PlPL]: 'Polski',
  [Locales.PtBR]: 'Português (Brasil)',
  [Locales.PtPT]: 'Português',
  [Locales.SvSE]: 'Svenska',
};
